module.exports = "<div class=\"activity-indicator-wrapper\">\r\n    <div class=\"activity-indicator\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/activity-indicator/activity-indicator.component.html
// module id = ./src/app/shared/components/activity-indicator/activity-indicator.component.html
// module chunks = main